import React from 'react';

interface Props {
  examName: string;
}

const AdditionalContentCard = (props) => {
  const DefaultAdditionalContentCard = () => null;

  const ExamAdditionalContentCard = React.lazy(() => {
    return import(`./exams/${props.examName.trim().toLowerCase().replace(/ /g, '_')}`).catch((error) => {
      return { default: DefaultAdditionalContentCard };
    })
  });

  return <ExamAdditionalContentCard />;
};

export default AdditionalContentCard;
